import { FC } from 'react';

import { useSelector } from 'react-redux';

import { NarrationToolbar } from '../narration-toolbar';
import { NarrationRecorder } from '../narration-recorder';
import { NarrationPermission } from '../narration-permission';
import { NarrationModal } from '../narration-modal';

import { narrationModel } from '../../model';

import { NarrationCountdown } from '../narration-countdown';
import { NarrationCountdownState } from '../../model/types';
import { NarrationSettings } from '../narration-settings';

export const Narration: FC = () => {
  const { countdownState } = useSelector(
    narrationModel.selectors.selectNarration
  );

  const isNarrationRecordingSessionActive = useSelector(
    narrationModel.selectors.checkIsNarrationRecordingSessionActive
  );

  const isNarrationCountdownActive = useSelector(
    narrationModel.selectors.checkIsNarrationCountdownActive
  );

  const isNarrationCountdownIdle =
    countdownState === NarrationCountdownState.Idle;

  return (
    <>
      <div className="flex flex-col gap-3 mt-5 w-full">
        {!isNarrationRecordingSessionActive && <NarrationSettings />}
        <NarrationPermission />
        <NarrationRecorder />
        {isNarrationRecordingSessionActive && !isNarrationCountdownIdle && (
          <NarrationToolbar />
        )}
      </div>
      {isNarrationCountdownActive && <NarrationCountdown />}
      <NarrationModal />
    </>
  );
};
